namespace $.$$ {
	
	const { hsla, blur } = $mol_style_func
	
	$mol_style_define( $shm_hitalama_map_head, {
		
		flex: {
			direction: 'row',
		},
		position: 'absolute',
		zIndex: $mol_layer.float,

		background: {
			color: $mol_theme.back,
		},
		box: {
			shadow: [
				[ 0, `-0.5rem`, `0.5rem`, `-0.5rem`, hsla( 0, 0, 0, .25 ) ],
				[ 0, `0.5rem`, `0.5rem`, `-0.5rem`, hsla( 0, 0, 0, .25 ) ],
				[ 0, `1px`, 0, 0, hsla( 0, 0, 0, .1 ) ],
			],
		},
		border: {
			radius: $mol_gap.round,
		},

		Wrapper: {
			width: 'stretch' as any,
			background: {
				color: $mol_theme.card,
			},
			flex: {
				grow: 1,
			},
			border: {
				radius: $mol_gap.round,
			},
		},
		Wrapper2: {
			width: 'stretch' as any,
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
			flex: {
				grow: 1,
			},
			border: {
				radius: $mol_gap.round,
			},
		},
		Widget_list_visible: {
			position: 'absolute',
			top: '0.75rem',
			right: '-2.75rem',
			zIndex: $mol_layer.float,
		},
		Rights_visible: {
			position: 'absolute',
			top: '0.75rem',
			right: '-5.5rem',
			zIndex: $mol_layer.float,
		},
		Drawing_tools_visible: {
			position: 'absolute',
			top: '0.75rem',
			right: '-8.25rem',
			zIndex: $mol_layer.float,
		},
		// backgroundColor: '#132230',
		Interaction_locked: {
			position: 'absolute',
			top: '0.75rem',
			right: '-11rem',
			zIndex: $mol_layer.float,
		},

		Title: {
			// ['fieldSizing' as any]: 'content',
			flex: {
				grow: 0,
			},
		},

	} )
	
}
